import EditRoundedIcon from '@mui/icons-material/EditRounded';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { LabelType } from 'generated/graphql';
import { FieldNames } from 'v2/core/entities/fields';
import { shallow } from 'zustand/shallow';
import { useChartTooltipStore } from '../hooks';

interface EditReasonProps {
  isMenuItem?: boolean;
}

export const EditReason = ({ isMenuItem = false }: EditReasonProps) => {
  const { payload, setData, fieldName, shouldShowEditReason } =
    useChartTooltipStore(
      ({ payload, setData, fieldName, shouldShowEditReason }) => ({
        payload,
        setData,
        fieldName,
        shouldShowEditReason,
      }),
      shallow,
    );

  const openDrawer = () => {
    const activeReason = payload?.id
      ? {
          id: payload?.id || '',
          displayName: payload?.label || '',
          isVisible: true,
          updateInProgress: false,
          type: LabelType.Reason,
          metadata: {
            category: payload?.category,
          },
        }
      : null;

    setData({
      activeReason,
      shouldShowEditReasonDrawer: true,
    });
  };

  if (fieldName !== FieldNames.Reason) {
    return null;
  }

  if (!shouldShowEditReason) {
    return null;
  }

  if (isMenuItem) {
    return (
      <MenuItem onClick={openDrawer}>
        <ListItemIcon>
          <EditRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Edit Reason" />
      </MenuItem>
    );
  }

  return (
    <>
      <ListItem disablePadding onClick={openDrawer}>
        <ListItemButton>
          <ListItemIcon>
            <EditRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="Edit Reason" />
        </ListItemButton>
      </ListItem>
    </>
  );
};
